import "core-js/modules/es.array.map.js";
/* eslint-disable react/prop-types */
import React from 'react';
import { useId } from '@applyboard/ui-components';
import { _StageCardWrapper, CollapsibleDiv } from "./style";
import StageCardHeader from "./StageCardHeader";
import RequirementCard from "../RequirementCard";
var StageCard = function StageCard(_ref) {
  var displayStageName = _ref.displayStageName,
    expanded = _ref.expanded,
    preview = _ref.preview,
    previewRequirement = _ref.previewRequirement,
    requirements = _ref.requirements,
    stageEmpty = _ref.stageEmpty,
    stageSubtitle = _ref.stageSubtitle,
    statusCounts = _ref.statusCounts,
    toggleExpand = _ref.toggleExpand,
    onChangeRequirementStatus = _ref.onChangeRequirementStatus,
    onEditRequirement = _ref.onEditRequirement,
    onToggleConditionModal = _ref.onToggleConditionModal,
    userPermissions = _ref.userPermissions,
    tab = _ref.tab,
    highlightedRequirementId = _ref.highlightedRequirementId,
    DocumentVerificationModal = _ref.DocumentVerificationModal,
    reloadAggregatedData = _ref.reloadAggregatedData,
    RemoveFileDialog = _ref.RemoveFileDialog,
    HybridRequirementDialogButton = _ref.HybridRequirementDialogButton,
    HybridRequirementDecisionReasons = _ref.HybridRequirementDecisionReasons,
    aggregatedDataRequirements = _ref.aggregatedDataRequirements;
  var headingId = useId();
  return /*#__PURE__*/React.createElement(_StageCardWrapper, null, /*#__PURE__*/React.createElement(StageCardHeader, {
    expanded: expanded,
    preview: preview,
    subtitle: stageSubtitle,
    title: displayStageName,
    toggleExpand: toggleExpand,
    statusCounts: statusCounts,
    stageEmpty: stageEmpty,
    headingId: headingId
  }), /*#__PURE__*/React.createElement(CollapsibleDiv, {
    role: "list",
    "aria-labelledby": headingId,
    expanded: expanded
  }, !stageEmpty && requirements.map(function (requirement) {
    return /*#__PURE__*/React.createElement(RequirementCard, {
      userPermissions: userPermissions,
      key: "requirement-".concat(requirement.id),
      requirement: requirement,
      highlightedRequirementId: highlightedRequirementId,
      preview: preview,
      previewRequirement: previewRequirement,
      onEdit: onEditRequirement,
      onStatusChange: onChangeRequirementStatus,
      onToggleConditionModal: onToggleConditionModal,
      isApplicantRequirement: tab === 'applicant requirements',
      DocumentVerificationModal: DocumentVerificationModal,
      reloadAggregatedData: reloadAggregatedData,
      RemoveFileDialog: RemoveFileDialog,
      HybridRequirementDecisionReasons: HybridRequirementDecisionReasons,
      HybridRequirementDialogButton: HybridRequirementDialogButton,
      aggregatedDataRequirements: aggregatedDataRequirements
    });
  })));
};
export default StageCard;